import { Component, Input, OnChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SegmentProvider } from '../../providers/analytics/segment';
import { AnalyticsEventType, SegmentLocationNames } from '../../model/types/analytics.const';
import {
  HOME_PARTNERS_ASSETS_PATH, HOME_PARTNERS_MARQUEE_MIN, HOME_PARTNERS_MARQUEE_MS_PER_LOGO, IHomeCorridorPreset, IHomePartnerLogo
} from '../../model/types/home-revamp-types';
import { HomeRevamp } from '../../providers/homescreen/home-revamp';
import { homeTranslate } from '../../providers/homescreen/home-revamp-translate';

@Component({
  selector: 'rmt-home-partners',
  templateUrl: 'rmt-home-partners.html'
})
export class RmtHomePartnersComponent implements OnChanges {
  @Input() preset: IHomeCorridorPreset;
  @Input() receiveCountry: string = '';
  @Input() locale: string = '';
  tagline: string = '';
  title: string = '';
  readonly marqueeCopies: number[] = [0, 1, 2];

  constructor(private analytics: SegmentProvider, private translate: TranslateService) { }

  ngOnChanges() {
    this.tagline = this.preset ? HomeRevamp.buildPartnersTagline(this.preset.hasWallets, (key: string) => this.translate.instant(key)) : '';
    this.title = this.preset ? homeTranslate(this.translate, 'page.home.partners.title', { receiveCountry: this.receiveCountry }) : '';
  }

  get isMarquee(): boolean {
    return !!this.preset && this.preset.partners.length >= HOME_PARTNERS_MARQUEE_MIN;
  }

  get marqueeDuration(): string {
    return `${(this.preset ? this.preset.partners.length : 0) * HOME_PARTNERS_MARQUEE_MS_PER_LOGO}ms`;
  }

  logoSrc(logo: IHomePartnerLogo): string {
    return `${HOME_PARTNERS_ASSETS_PATH}/${logo.file}`;
  }

  trackCardClick(extra: { [key: string]: string | number } = {}) {
    this.analytics.trackEvent({
      eventName: AnalyticsEventType.ElementClicked,
      analyticsData: {
        elementId: 'home_payout_partner_card',
        elementType: 'card',
        area: 'home.payout_partners',
        location: SegmentLocationNames.Home,
        locale: this.locale,
        ...extra
      }
    });
  }

  onPartnerClick(event: Event, logo: IHomePartnerLogo, position: number) {
    event.stopPropagation();
    this.trackCardClick({ elementLabel: logo.alt, elementPosition: position });
  }
}



// WEBPACK FOOTER //
// ./src/components/rmt-home-partners/rmt-home-partners.ts